/**
 * @generated SignedSource<<23b73812a6491aefc4dff0d3fc131ae0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifier",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finish",
  "storageKey": null
},
v8 = {
  "kind": "Literal",
  "name": "first",
  "value": 500
},
v9 = {
  "kind": "Literal",
  "name": "state",
  "value": "TRADE_RULE_STATE_ACCEPTED"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tradeType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "communityId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "residualId",
  "storageKey": null
},
v15 = [
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "TradePoint",
    "kind": "LinkedField",
    "name": "tradePoint",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Meter",
        "kind": "LinkedField",
        "name": "meter",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Property",
            "kind": "LinkedField",
            "name": "property",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hours",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "minutes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "seconds",
    "storageKey": null
  }
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "ClauseConnection",
  "kind": "LinkedField",
  "name": "clauses",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClauseEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Clause",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "price",
              "storageKey": null
            },
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timezone",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ignoreDaylightSavings",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ignorePublicHolidays",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "monthsOfYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "daysOfWeek",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeSpan",
              "kind": "LinkedField",
              "name": "timesOfDay",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeOfDayType",
                  "kind": "LinkedField",
                  "name": "start",
                  "plural": false,
                  "selections": (v16/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeOfDayType",
                  "kind": "LinkedField",
                  "name": "finish",
                  "plural": false,
                  "selections": (v16/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "proposedAt",
  "storageKey": null
},
v19 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "givenName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "familyName",
    "storageKey": null
  }
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "proposedBy",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "acceptedAt",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "acceptedBy",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v23 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TradeRuleEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TradeRule",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Trader",
            "kind": "LinkedField",
            "name": "buyer",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Trader",
            "kind": "LinkedField",
            "name": "seller",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          (v17/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v18/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v24 = [
  (v12/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": (v19/*: any*/),
    "storageKey": null
  },
  (v13/*: any*/),
  (v14/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "TradePoint",
    "kind": "LinkedField",
    "name": "tradePoint",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v25 = [
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "TradePoint",
    "kind": "LinkedField",
    "name": "tradePoint",
    "plural": false,
    "selections": [
      (v2/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_TradeRuleActive_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Property",
        "kind": "LinkedField",
        "name": "property",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TradeRuleActive_property"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_TradeRuleActive_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Property",
        "kind": "LinkedField",
        "name": "property",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "line1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "line2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postcode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Gps",
                "kind": "LinkedField",
                "name": "gps",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "latitude",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "longitude",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MeterConnection",
            "kind": "LinkedField",
            "name": "meters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeterEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Meter",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tradePointId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRange",
                        "kind": "LinkedField",
                        "name": "active",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "communityRules",
                        "args": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "TRADE_TYPE_COMMUNITY"
                          }
                        ],
                        "concreteType": "TradeRuleConnection",
                        "kind": "LinkedField",
                        "name": "rules",
                        "plural": false,
                        "selections": (v23/*: any*/),
                        "storageKey": "rules(first:500,state:\"TRADE_RULE_STATE_ACCEPTED\",type:\"TRADE_TYPE_COMMUNITY\")"
                      },
                      {
                        "alias": "contractedRules",
                        "args": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "TRADE_TYPE_CONTRACTED"
                          }
                        ],
                        "concreteType": "TradeRuleConnection",
                        "kind": "LinkedField",
                        "name": "rules",
                        "plural": false,
                        "selections": (v23/*: any*/),
                        "storageKey": "rules(first:500,state:\"TRADE_RULE_STATE_ACCEPTED\",type:\"TRADE_TYPE_CONTRACTED\")"
                      },
                      {
                        "alias": "nominatedRules",
                        "args": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "TRADE_TYPE_NOMINATED"
                          }
                        ],
                        "concreteType": "TradeRuleConnection",
                        "kind": "LinkedField",
                        "name": "rules",
                        "plural": false,
                        "selections": (v23/*: any*/),
                        "storageKey": "rules(first:500,state:\"TRADE_RULE_STATE_ACCEPTED\",type:\"TRADE_TYPE_NOMINATED\")"
                      },
                      {
                        "alias": "proposedRules",
                        "args": [
                          (v8/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "state",
                            "value": "TRADE_RULE_STATE_PROPOSED"
                          }
                        ],
                        "concreteType": "TradeRuleConnection",
                        "kind": "LinkedField",
                        "name": "rules",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeRuleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TradeRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Trader",
                                    "kind": "LinkedField",
                                    "name": "buyer",
                                    "plural": false,
                                    "selections": (v24/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Trader",
                                    "kind": "LinkedField",
                                    "name": "seller",
                                    "plural": false,
                                    "selections": (v24/*: any*/),
                                    "storageKey": null
                                  },
                                  (v17/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v18/*: any*/),
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "rules(first:500,state:\"TRADE_RULE_STATE_PROPOSED\")"
                      },
                      {
                        "alias": "residualRules",
                        "args": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "TRADE_TYPE_RESIDUAL"
                          }
                        ],
                        "concreteType": "TradeRuleConnection",
                        "kind": "LinkedField",
                        "name": "rules",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeRuleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TradeRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Trader",
                                    "kind": "LinkedField",
                                    "name": "buyer",
                                    "plural": false,
                                    "selections": (v25/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Trader",
                                    "kind": "LinkedField",
                                    "name": "seller",
                                    "plural": false,
                                    "selections": (v25/*: any*/),
                                    "storageKey": null
                                  },
                                  (v17/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v18/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "rules(first:500,state:\"TRADE_RULE_STATE_ACCEPTED\",type:\"TRADE_TYPE_RESIDUAL\")"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "41bad7b9654439f0640af40c760371e3",
    "id": null,
    "metadata": {},
    "name": "routes_TradeRuleActive_Query",
    "operationKind": "query",
    "text": "query routes_TradeRuleActive_Query(\n  $id: ID!\n) {\n  property(id: $id) {\n    ...TradeRuleActive_property\n    id\n  }\n}\n\nfragment CommunityTradeRules_property on Property {\n  id\n  meters {\n    edges {\n      node {\n        id\n        identifier\n        title\n        tradePointId\n        active {\n          start\n          finish\n        }\n        communityRules: rules(first: 500, type: TRADE_TYPE_COMMUNITY, state: TRADE_RULE_STATE_ACCEPTED) {\n          edges {\n            node {\n              id\n              priority\n              tradeType\n              state\n              buyer {\n                userId\n                communityId\n                residualId\n                tradePoint {\n                  id\n                  meter {\n                    id\n                    identifier\n                    title\n                    property {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n              seller {\n                userId\n                communityId\n                residualId\n                tradePoint {\n                  id\n                  meter {\n                    id\n                    identifier\n                    title\n                    property {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n              clauses {\n                edges {\n                  node {\n                    price\n                    id\n                    timezone\n                    ignoreDaylightSavings\n                    ignorePublicHolidays\n                    monthsOfYear\n                    daysOfWeek\n                    timesOfDay {\n                      start {\n                        hours\n                        minutes\n                        seconds\n                      }\n                      finish {\n                        hours\n                        minutes\n                        seconds\n                      }\n                    }\n                  }\n                }\n              }\n              start\n              finish\n              proposedAt\n              proposedBy {\n                id\n                email\n                givenName\n                familyName\n              }\n              acceptedAt\n              acceptedBy {\n                id\n                email\n                givenName\n                familyName\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ContractedTradeRules_property on Property {\n  id\n  meters {\n    edges {\n      node {\n        id\n        identifier\n        title\n        tradePointId\n        contractedRules: rules(first: 500, type: TRADE_TYPE_CONTRACTED, state: TRADE_RULE_STATE_ACCEPTED) {\n          edges {\n            node {\n              id\n              priority\n              tradeType\n              state\n              buyer {\n                userId\n                communityId\n                residualId\n                tradePoint {\n                  id\n                  meter {\n                    id\n                    identifier\n                    title\n                    property {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n              seller {\n                userId\n                communityId\n                residualId\n                tradePoint {\n                  id\n                  meter {\n                    id\n                    identifier\n                    title\n                    property {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n              clauses {\n                edges {\n                  node {\n                    price\n                    id\n                    timezone\n                    ignoreDaylightSavings\n                    ignorePublicHolidays\n                    monthsOfYear\n                    daysOfWeek\n                    timesOfDay {\n                      start {\n                        hours\n                        minutes\n                        seconds\n                      }\n                      finish {\n                        hours\n                        minutes\n                        seconds\n                      }\n                    }\n                  }\n                }\n              }\n              start\n              finish\n              proposedAt\n              proposedBy {\n                id\n                email\n                givenName\n                familyName\n              }\n              acceptedAt\n              acceptedBy {\n                id\n                email\n                givenName\n                familyName\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NominatedTradeRules_property on Property {\n  id\n  meters {\n    edges {\n      node {\n        id\n        identifier\n        title\n        tradePointId\n        active {\n          start\n          finish\n        }\n        nominatedRules: rules(first: 500, type: TRADE_TYPE_NOMINATED, state: TRADE_RULE_STATE_ACCEPTED) {\n          edges {\n            node {\n              id\n              priority\n              tradeType\n              state\n              buyer {\n                userId\n                communityId\n                residualId\n                tradePoint {\n                  id\n                  meter {\n                    id\n                    identifier\n                    title\n                    property {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n              seller {\n                userId\n                communityId\n                residualId\n                tradePoint {\n                  id\n                  meter {\n                    id\n                    identifier\n                    title\n                    property {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n              clauses {\n                edges {\n                  node {\n                    price\n                    id\n                    timezone\n                    ignoreDaylightSavings\n                    ignorePublicHolidays\n                    monthsOfYear\n                    daysOfWeek\n                    timesOfDay {\n                      start {\n                        hours\n                        minutes\n                        seconds\n                      }\n                      finish {\n                        hours\n                        minutes\n                        seconds\n                      }\n                    }\n                  }\n                }\n              }\n              start\n              finish\n              proposedAt\n              proposedBy {\n                id\n                email\n                givenName\n                familyName\n              }\n              acceptedAt\n              acceptedBy {\n                id\n                email\n                givenName\n                familyName\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProposedTradeRules_property on Property {\n  id\n  meters {\n    edges {\n      node {\n        id\n        identifier\n        title\n        tradePointId\n        proposedRules: rules(first: 500, state: TRADE_RULE_STATE_PROPOSED) {\n          edges {\n            node {\n              id\n              priority\n              tradeType\n              state\n              buyer {\n                userId\n                user {\n                  id\n                  email\n                  givenName\n                  familyName\n                }\n                communityId\n                residualId\n                tradePoint {\n                  id\n                  type\n                }\n              }\n              seller {\n                userId\n                user {\n                  id\n                  email\n                  givenName\n                  familyName\n                }\n                communityId\n                residualId\n                tradePoint {\n                  id\n                  type\n                }\n              }\n              clauses {\n                edges {\n                  node {\n                    price\n                    id\n                    timezone\n                    ignoreDaylightSavings\n                    ignorePublicHolidays\n                    monthsOfYear\n                    daysOfWeek\n                    timesOfDay {\n                      start {\n                        hours\n                        minutes\n                        seconds\n                      }\n                      finish {\n                        hours\n                        minutes\n                        seconds\n                      }\n                    }\n                  }\n                }\n              }\n              start\n              finish\n              proposedAt\n              proposedBy {\n                id\n                email\n                givenName\n                familyName\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ResidualTradeRules_property on Property {\n  id\n  meters {\n    edges {\n      node {\n        id\n        identifier\n        title\n        tradePointId\n        residualRules: rules(first: 500, type: TRADE_TYPE_RESIDUAL, state: TRADE_RULE_STATE_ACCEPTED) {\n          edges {\n            node {\n              id\n              priority\n              tradeType\n              state\n              buyer {\n                userId\n                communityId\n                residualId\n                tradePoint {\n                  id\n                }\n              }\n              seller {\n                userId\n                communityId\n                residualId\n                tradePoint {\n                  id\n                }\n              }\n              clauses {\n                edges {\n                  node {\n                    price\n                    id\n                    timezone\n                    ignoreDaylightSavings\n                    ignorePublicHolidays\n                    monthsOfYear\n                    daysOfWeek\n                    timesOfDay {\n                      start {\n                        hours\n                        minutes\n                        seconds\n                      }\n                      finish {\n                        hours\n                        minutes\n                        seconds\n                      }\n                    }\n                  }\n                }\n              }\n              start\n              finish\n              proposedAt\n              proposedBy {\n                id\n                email\n                givenName\n                familyName\n              }\n              acceptedAt\n              acceptedBy {\n                id\n                email\n                givenName\n                familyName\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment TradeRuleActive_property on Property {\n  id\n  title\n  address {\n    line1\n    line2\n    city\n    state\n    postcode\n    gps {\n      latitude\n      longitude\n    }\n    id\n  }\n  ...CommunityTradeRules_property\n  ...ContractedTradeRules_property\n  ...NominatedTradeRules_property\n  ...ProposedTradeRules_property\n  ...ResidualTradeRules_property\n}\n"
  }
};
})();

node.hash = "b0debb73ce2e4c10096d007ca8a5113c";

module.exports = node;
